import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Header from "../../components/layout/Header";
import PageTitle from "../../components/layout/PageTitle";
import NotFound from "../../assets/Images/not-found.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from '@fortawesome/free-solid-svg-icons';
import BlogCard from "../../components/cards/BlogCard";
import WrapperBlog from "../../components/layout/WrapperBlog";
import Footer from "../../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import {BLOG_API_BASE, PUBLIC_S3_BASE, SITE_URL} from "../../utils/apiConfig";
import {useLanguage} from "../../context/LanguageProvider";
import SEO from "../../components/layout/SEO";


const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0); // Store total pages
    const itemsPerPage = 12; // Number of blogs per page

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(BLOG_API_BASE, {
                    params: {
                        language: lang,
                        page: currentPage + 1,
                        limit: itemsPerPage
                    }
                });

                if (response.data && Array.isArray(response.data.data)) {
                    setBlogs(response.data.data);
                    setFilteredBlogs(response.data.data);
                    setTotalPages(response.data.pagination.totalPages); // Set total pages
                } else {
                    setBlogs([]);
                    setFilteredBlogs([]);
                    setTotalPages(0);
                }
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
                setBlogs([]);
                setFilteredBlogs([]);
                setTotalPages(0);
            }
        };

        fetchBlogs();
    }, [currentPage]); // Re-fetch blogs when currentPage changes

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const currentBlogs = blogs;
    const { lang, t } = useLanguage();

    console.log(PUBLIC_S3_BASE);
    return (
        <>

            <SEO
                title={t.blog.title}
                description={t.blog.description}
                path="/blog"
            />

            <div className='min-h-screen flex flex-col'>
                <Header/>
                <main className='flex-1'>
                    <WrapperBlog className='my-10'>
                        {Array.isArray(currentBlogs) && currentBlogs.length > 0 ? (
                            <>
                                <div className="flex items-center mb-10 leading-4 lg:leading-2 px-3 md:px-1">
                                    <PageTitle title={t.blog.title} />
                                </div>

                                <div className="grid grid-cols-1 p-3 lg:p-0 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
                                    {currentBlogs.map(blogs => (
                                        <article key={blogs.id} className='w-full'>
                                            <Link to={`/${lang}/blog/${blogs.slug}`}>
                                                <BlogCard blog={blogs}/>
                                            </Link>
                                        </article>
                                    ))}
                                </div>

                                <ReactPaginate
                                    previousLabel={t.utils.before}
                                    nextLabel={t.utils.after}
                                    breakLabel={'...'}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination flex justify-center mt-4'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                />
                            </>
                        ) : (
                            <div className='w-full relative mb-20'>
                                <img src={NotFound} alt='Article not found' className='w-1/2 m-auto'/>
                                <p className='text-3xl text-center my-5'>{t.blog.not_found}</p>
                            </div>
                        )}
                    </WrapperBlog>
                </main>
                <Footer/>
            </div>
        </>
    );
};

export default BlogList;
